/**
 * Re-export IF events from domain package
 */
export { IFEvents, IFEventType, IFEventCategory, IFEventCategoryType } from '@sharpee/if-domain';
